import type { MeResponse } from '@lunya/contracts'
import { API_PATHS } from '@lunya/contracts'

import { createQuery } from '~/shared/api'

import { mapUserFromApi } from './mappers/mapUserFromApi'

/** GET /users/me — профиль текущего пользователя. */
export const UserQuery = createQuery<void, MeResponse, ReturnType<typeof mapUserFromApi>>({
  key: 'user.me',
  path: API_PATHS.user.me,
  transform: mapUserFromApi,
  cacheBehavior: 'default',
})
